import { QRCodeCanvas } from "qrcode.react";
import { Button, Modal, ModalActions, ModalContent, ModalTitle, Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { Stack } from "@kaltura/mediaspace-shared-styled";
import { ButtonAnalyticsProvider, useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

interface QrCodeModalProps {
    open: boolean;
    onClose: () => void;
}

/**
 * Modal with a QR code for installing the PWA on a mobile device.
 */
export const QrCodeModal = (props: QrCodeModalProps) => (
    <ButtonAnalyticsProvider location={"Modal - QR Code"}>
        <QrCodeModalContent {...props} />
    </ButtonAnalyticsProvider>
);

const QrCodeModalContent = ({ onClose, ...props }: QrCodeModalProps) => {
    const sendButtonAnalytics = useButtonAnalytics();

    const handleClose = (actionName: string) => {
        sendButtonAnalytics(actionName, ButtonClickAnalyticsType.CLOSE);
        onClose();
    };

    return (
        <Modal {...props} onClose={() => handleClose("Dismiss qr code modal")} fullWidth={true}>
            <ModalTitle onClose={() => handleClose("Close qr code modal")}>
                {translate("Install via QR code")}
            </ModalTitle>
            <ModalContent>
                <Stack direction={"column"} alignItems={"center"} gap={3}>
                    <Typography variant={"body1"}>
                        {translate("Scan QR code below to install app on iPhone or Android smartphone.")}
                    </Typography>
                    <QRCodeCanvas
                        value={window.location.href}
                        size={220}
                        marginSize={4}
                        className={"chromatic-ignore"}
                    />
                </Stack>
            </ModalContent>
            <ModalActions>
                <Button variant={"borderless"} color={"secondary"} onClick={() => handleClose("Dismiss qr code modal")}>
                    {translate("Close")}
                </Button>
            </ModalActions>
        </Modal>
    );
};
